import React from 'react'

import { HomeCharBar } from 'src/components/HomeCharBar'
import Container from 'src/components/Container'
import AppBreadcrumb from 'src/components/AppBreadcrumb'

import { useAnalytics } from 'src/pages/Analytics/useAnalytics'

const Analytics = (): JSX.Element => {
  const { breadcrumbItems } = useAnalytics()

  return (
    <Container>
      <AppBreadcrumb items={breadcrumbItems} />
      <div className="mt-3">
        <HomeCharBar />
      </div>
    </Container>
  )
}

export default Analytics
